
/* injects from baggage-loader */

'use strict';

export default class LogoutController {

	constructor($log, $location, User) {
		'ngInject';

		this.$log = $log;
		this.$location = $location;
		this.User = User;

	}

	async $onInit() {

		// Logout the current user
		await this.User.logout();

		// Redirect to login page
		this.$location.url('/login').replace();

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/logout/logout.controller.js